import React from "react";
import Popup from "../../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import trans from "../../../../utils";
import { Tag } from "antd";
import Close from "../../../Helpers/CloseBtn/Close";
import InspectionRequestConsultantQA from "../../../InspectionRequest/InspectionRequestPopup/InspectionRequestConsultantQA";

export default function IRConsultantReview({
	consAction,
	setConsAction,
	irId,
	setAction,
}) {
	return (
		<>
			<Popup show={consAction} size="lg">
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={trans("Consultant Review")}
							subtitle={<Tag color="orange">{irId?.ir_number || ""}</Tag>}
						/>
					</Modal.Title>
					<Close
						style="close-32 close"
						close={() => setConsAction(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable">
					<InspectionRequestConsultantQA
						setQAAction={setConsAction}
						irId={irId}
						setAction={setAction}
					/>
				</Modal.Body>
			</Popup>
		</>
	);
}
